export { default } from './PricingView';



// WEBPACK FOOTER //
// ./src/components/views/PricingView/index.js